<template>
    <div>
        <WhiteButton @click="clickOk()" 
            customClass="p-2 w-full font-bold"
        >
            {{ lbl.myOrder.tracking.contactCallcenter }}
        </WhiteButton>
    </div>
</template>
<script>
import { inject } from 'vue'
// component
import WhiteButton from '@/components/Button/WhiteButton.vue'

export default {
    name: 'Contact',
    props: {},
    components: {
        WhiteButton
    },
    mixins: [],
    emits: ["onClick"],
    data: function () { return {} },
    computed: {},
    setup: function () {
        const { lbl } = inject("LocaleStore")

        return {
            lbl
        }
    },
    mounted: function () { },
    methods: {
        clickOk: function () {
            this.$emit("onClick")
        }
    }
}
</script>
